@if (appConfig.update() === 'required') {
<div
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="app-update-title"
  class="fixed inset-0 z-[1100] flex flex-col items-center justify-center bg-vw-bg px-6 pt-safe-top pb-safe-bottom text-center"
>
  <img
    src="assets/images/willy/willy_phone.png"
    alt=""
    class="h-[120px] w-[120px] rounded-pill bg-vw-surface-tint object-cover object-top"
  />
  <h1 id="app-update-title" class="mt-6 text-title-l text-vw-ink">
    {{ "app-update.required.title" | translate }}
  </h1>
  <p class="mt-3 text-body text-vw-body">
    {{ appConfig.message() ?? ("app-update.required.text" | translate) }}
  </p>
  <vw-button
    look="primary"
    [label]="'app-update.required.action' | translate"
    customClass="mt-8 w-full"
    class="w-full"
    (onClick)="appConfig.openStore()"
  />
  <button
    type="button"
    class="mt-2 min-h-target w-full text-body-s font-semibold text-vw-primary-ink"
    (click)="appConfig.continueInBrowser()"
  >
    {{ "app-update.required.browser" | translate }}
  </button>
</div>
}
